@if (canCreateCorrection$ | async) {
  <button class="dropdown-item"
    [innerHTML]="'context-menu.actions.request-correction.btn' | translate"
    (click)="$event.preventDefault();openRequestModal(requestCorrectionModal);">
  </button>
}

<ng-template #requestCorrectionModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'context-menu.actions.request-correction.title' | translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{'context-menu.actions.request-correction.info' | translate}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="c('cancel')">{{'context-menu.actions.request-correction.confirm.cancel' | translate}}</button>
    <button type="button" class="btn btn-success" (click)="requestCorrection()" [dsBtnDisabled]="(processing$ | async)">
      @if ((processing$ | async)) {
        <span><i class='fas fa-circle-notch fa-spin'></i> {{'submission.workflow.tasks.generic.processing' | translate}}</span>
      }
      @if ((processing$ | async) !== true) {
        <span>{{'context-menu.actions.request-correction.confirm.submit' | translate}}</span>
      }
    </button>
  </div>
</ng-template>
